import ValueDeserializerInterface from "./ValueDeserializer/ValueDeserializerInterface"
import Game, { SerializedGame } from "../Model/Game"
import Fighter from "../Model/Fighter"
import ValueInterface, {
  SerializedValueType,
} from "../Model/Value/ValueInterface"
import FighterInterface, {
  SerializedFighterType,
} from "../Model/FighterInterface"

export default class GameDeserializer {
  constructor(
    private readonly valueDeserializers: ValueDeserializerInterface[],
  ) {
    this.valueDeserializers.forEach(
      (valueDeserializer: ValueDeserializerInterface): void => {
        if (valueDeserializer.setSerializer !== undefined) {
          valueDeserializer.setSerializer(this)
        }
      },
    )
  }

  public deserialize(payload: SerializedGame): Game {
    return new Game(
      payload.id,
      this.deserializeFighter(payload.current),
      payload.next.map(this.deserializeFighter),
      payload.enemiesQueue,
      payload.time,
      payload.level,
      payload.initialValue,
      payload.status,
      payload.defeatReason,
    )
  }

  private deserializeFighter(payload: SerializedFighterType): FighterInterface {
    return new Fighter(
      payload.id,
      payload.type,
      this.deserializeValue(payload.value),
      payload.position,
      payload.status,
    )
  }

  public deserializeValue(value: SerializedValueType): ValueInterface {
    for (const deserializer of this.valueDeserializers) {
      if (deserializer.supports(value)) {
        return deserializer.deserialize(value)
      }
    }

    throw new Error("Unknown value deserializer.")
  }
}
